import { useState } from "react";
import { useSignUpSignIn } from "../../utils/signUpSignIn";
import { useStore } from "react-redux";
import { FaRegEnvelope, FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import './registerLogin.css'




export default function Register() {
    
    const [shown, setShown] = useState(false);

    const {
        isRegisterActive,
        isSignIn,
        isSignUp,
        signUpChooser,
        signInChooser,
        handleChangeSignIn,
        handleChangeSignUp,
        handleSubmitSignUp,
        handleSubmitSignIn,
        handleViewPassword,
    } = useSignUpSignIn();

    return (
        <div className="registerLoginContainer">
            <div className={isRegisterActive ? "login-container right-panel-active" : "login-container"} id="container">
                <div className="content1 sign-in-container">
                    <form className="login" onSubmit={handleSubmitSignIn}>
                        <h2 className="tituloForm1">Login</h2>
                        <p className="texto"> Iniciar sesión con un correo electrónico existente</p>
                        <div className="socialMedia">
                            <a className="icone4" href="#"><svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 640 512">{/*Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}<path d="M386.1 228.5c1.8 9.7 3.1 19.4 3.1 32C389.2 370.2 315.6 448 204.8 448c-106.1 0-192-85.9-192-192s85.9-192 192-192c51.9 0 95.1 18.9 128.6 50.3l-52.1 50c-14.1-13.6-39-29.6-76.5-29.6-65.5 0-118.9 54.2-118.9 121.3 0 67.1 53.4 121.3 118.9 121.3 76 0 104.5-54.7 109-82.8H204.8v-66h181.3zm185.4 6.4V179.2h-56v55.7h-55.7v56h55.7v55.7h56v-55.7H627.2v-56h-55.7z" /></svg></a>
                            <a className="icone5" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgFacebook" aria-hidden="true"><path d="M16.95 3h-2.7a4.5 4.5 0 00-4.5 4.5v2.7h-2.7v3.6h2.7V21h3.6v-7.2h2.7l.9-3.6h-3.6V7.5a.9.9 0 01.9-.9h2.7z"></path></svg></a>
                            <a className="icone6" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgLinkedin" aria-hidden="true"><path d="M21.024 14.807v5.968h-3.553v-5.968a1.778 1.778 0 00-3.553 0v5.968h-3.552V9.691h3.509v.326a5.476 5.476 0 011.82-.326 5.226 5.226 0 015.329 5.116zM2.976 20.775h3.7V9.691h-3.7zm0-15.7a1.848 1.848 0 101.848-1.85 1.848 1.848 0 00-1.848 1.847z"></path></svg></a>
                        </div>
                        <p className="texto">Inicia sesión con los datos creados aquí</p>
                        <label className="label-input">
                            <input
                                type="email"
                                placeholder="E-mail"
                                name="email"
                                value={isSignIn.email}
                                onChange={handleChangeSignIn}
                                required
                                autoFocus
                                />
                        </label>
                        <label className="label-input">
                            {/* <IoLockClosedOutline /> */}
                            <input
                                type={shown ? "text": "password"}
                                placeholder="Contraseña"
                                name="password"
                                value={isSignIn.password}
                                onChange={handleChangeSignIn}
                                required
                            />
                            <span onClick={() => setShown(!shown)}>{shown ? <FaRegEye /> : <FaRegEyeSlash />} </span>
                        </label>
                        <a className="forgot-password" href="#">Olvidé la contraseña</a>
                        <button type="submit" className="btn btnLogin1">Inicia Sesión</button>
                    </form>
                </div>
                <div className="content1 sign-up-container">
                    <form onSubmit={handleSubmitSignUp} className="login">
                        <h2 className="tituloForm2">Crear cuenta</h2>
                        <div className="socialMedia">
                            <a className="icone1" href="#"><svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 640 512">{/*Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.*/}<path d="M386.1 228.5c1.8 9.7 3.1 19.4 3.1 32C389.2 370.2 315.6 448 204.8 448c-106.1 0-192-85.9-192-192s85.9-192 192-192c51.9 0 95.1 18.9 128.6 50.3l-52.1 50c-14.1-13.6-39-29.6-76.5-29.6-65.5 0-118.9 54.2-118.9 121.3 0 67.1 53.4 121.3 118.9 121.3 76 0 104.5-54.7 109-82.8H204.8v-66h181.3zm185.4 6.4V179.2h-56v55.7h-55.7v56h55.7v55.7h56v-55.7H627.2v-56h-55.7z" /></svg></a>
                            <a className="icone2" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgFacebook" aria-hidden="true"><path d="M16.95 3h-2.7a4.5 4.5 0 00-4.5 4.5v2.7h-2.7v3.6h2.7V21h3.6v-7.2h2.7l.9-3.6h-3.6V7.5a.9.9 0 01.9-.9h2.7z"></path></svg></a>
                            <a className="icone3" href="#"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgLinkedin" aria-hidden="true"><path d="M21.024 14.807v5.968h-3.553v-5.968a1.778 1.778 0 00-3.553 0v5.968h-3.552V9.691h3.509v.326a5.476 5.476 0 011.82-.326 5.226 5.226 0 015.329 5.116zM2.976 20.775h3.7V9.691h-3.7zm0-15.7a1.848 1.848 0 101.848-1.85 1.848 1.848 0 00-1.848 1.847z"></path></svg></a>
                        </div>
                        <p className="texto">Regístrate y crea una nueva cuenta. Usa tu correo electrónico para registrarte</p>
                        <label className="label-input">
                            <input
                                type="text"
                                placeholder="Nombre"
                                name="name"
                                value={isSignUp.name}
                                onChange={handleChangeSignUp}
                                required
                                autoFocus
                            />
                        </label>
                        <label className="label-input">
                            <input
                                type="email"
                                placeholder="E-mail"
                                name="email"
                                value={isSignUp.email}
                                onChange={handleChangeSignUp}
                                required
                            />
                        </label>
                        <label className="label-input">
                            <input
                                type="password"
                                placeholder="Contraseña"
                                name="password"
                                value={isSignUp.password}
                                onChange={handleChangeSignUp}
                                required
                            />
                            <span onClick={() => setShown(!shown)}>{shown ? <FaRegEye /> : <FaRegEyeSlash />} </span>
                        </label>
                        <button type="submit" className="btn btnCadastro1">Registrar</button>
                    </form>
                </div>

                <div className="overlay-container">
                    <div className="overlay">
                        <div className="content2 contentEsq">
                            <h2 className="tituloInform">¡Bienvenido nuevamente!</h2>
                            <p className="texto2">Si ya tienes una cuenta, inicia sesión</p>
                            <button className="btn2 btnLogin2" id="signIn" onClick={signInChooser}>Iniciar Sesión</button>
                        </div>
                        <div className="content2 contentDir">
                            <h2 className="tituloInform">Hola, bienvenido</h2>
                            <p className="texto2">Regístrate con tu correo electrónico para unirte a nosotros</p>
                            <button className="btn2 btnCadastro2" id="signUp" onClick={signUpChooser}><span>Registrarse</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="noturno">
                <input type="checkbox" className="checkbox" id="checkbox" />
                <label htmlFor="checkbox" className="label">
                    <svg xmlns="http://www.w3.org/2000/svg" className="fa-moon" width="24" height="24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgMoon" aria-hidden="true"><path d="M17.745 16.334a7.162 7.162 0 01-3.855-13.2c-.241-.04-.484-.073-.731-.1S12.664 3 12.412 3a9 9 0 104.917 16.535 9.063 9.063 0 003.259-3.79 7.144 7.144 0 01-2.843.589z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" className="fa-sun" width="24" height="24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" data-icon="SvgSun" aria-hidden="true"><path d="M21 12h-2M5 12H3m15.4 6.4l-.75-.75-.75-.75M5.6 5.6l.75.75.75.75M12 21v-2m0-16v2m6.4.6l-.75.75-.75.75M5.6 18.4l.75-.75.75-.75M12 8a4 4 0 11-2.828 1.172A3.984 3.984 0 0112 8z"></path></svg>
                    <div className="ball"></div>
                </label>
            </div>
        </div>
    );
};





